#import "@/apollo/fragments/Client.gql"

mutation UpdateClient(
    $clientId: ID!
    $content: String!
    $name: String
    $imageProcessingEnabled: Boolean
    $fbAdsManagerConfig: InputFacebookAdsManagerConfig
    $connectModuleEnabled: Boolean
    $creativeXPlatformSettings: InputCreativeXPlatformSettings
) {
    updateClient(
        clientId: $clientId
        content: $content
        name: $name
        imageProcessingEnabled: $imageProcessingEnabled
        fbAdsManagerConfig: $fbAdsManagerConfig
        connectModuleEnabled: $connectModuleEnabled
        creativeXPlatformSettings: $creativeXPlatformSettings
    ) {
        ...Client
        fbAdsManagerConfig {
            businessId
            adAccountId
        }
        creativeXPlatformSettings {
            enabled
            brandId
            threshold
        }
    }
}
